module.exports = __webpack_public_path__ + "static/media/VIEWS-PitchOn.1857c493.svg";